<script setup lang="ts">
import VTransition from '@shared/animation/VTransition/VTransition.vue';
import { FontAwesomeIcon } from '@shared/plugin/icons';

withDefaults(
  defineProps<{
    valid: boolean;
    active?: boolean;
    iconSize?:
      | 'lg'
      | 'xs'
      | 'sm'
      | '1x'
      | '2x'
      | '3x'
      | '4x'
      | '5x'
      | '6x'
      | '7x'
      | '8x'
      | '9x'
      | '10x';
  }>(),
  {
    active: false,
    iconSize: undefined,
  },
);
</script>

<template>
  <div class="inline-grid">
    <VTransition type="flip">
      <FontAwesomeIcon
        :size="iconSize"
        icon="fas fa-check-circle"
        :class="['col-end-1 row-end-1', { 'text-primary-dark': active, 'text-primary': !active }]"
        v-if="valid"
      />
      <FontAwesomeIcon
        :size="iconSize"
        icon="far fa-circle"
        class="col-end-1 row-end-1 rounded-full bg-white text-grey"
        v-else
      />
    </VTransition>
  </div>
</template>
